import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { LocalStorageService } from '@us/web/shared/data-access';
import { getStringValue } from '@us/web/shared/utils';
import { ShopService } from '@us/web/shop/data-access';
import { isNil } from 'lodash';
import { map, Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ValidateShopIdGuard {
    private readonly router = inject(Router);
    private readonly localStorage = inject(LocalStorageService);
    private readonly shopService = inject(ShopService);

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentShopId = this.localStorage.getItem('shop_id');
        let requestShopId: string | null = getStringValue(route.queryParams['id']);
        const tableId = Number(route.queryParams['tableId']);

        if (requestShopId !== null && requestShopId.includes('/')) {
            // ? Payon payment callback
            requestShopId = (requestShopId as string).split('/')[0];
        }

        if (!isNil(requestShopId) && requestShopId !== currentShopId) {
            this.localStorage.setItem('shop_id', requestShopId);
            return true;
        }

        if (!isNil(currentShopId)) {
            return true;
        }

        if (tableId) {
            return this.shopService.getShopIdByTableId({ table_id: tableId }).pipe(
                tap({
                    next: ({ shop_id: shopId }) => {
                        if (shopId) {
                            this.localStorage.setItem('shop_id', shopId);
                        }
                    },
                    error: () => {
                        this.router.navigate(['/unavailable']);
                    }
                }),
                map(({ shop_id: shopId }) => !!shopId)
            );
        }
        this.router.navigate(['/unavailable']);
        return false;
    }
}
